import getViewportElement from './get-viewport-element.js';
function getScrollElement() {
    const foundationContent = document.querySelector('.c-foundation-application__content');
    return foundationContent || getViewportElement(true);
}
export { getScrollElement, };
//# sourceMappingURL=get-scroll-element.js.map